module.exports = __webpack_public_path__ + "img/uk_failure_6.44effb83.png";